function initSlickSlider($element, $dots, $arrows, $infinite, $autoplay, $speed, $slidesToShow, $slidesToScroll, $slidesToShowTab, $slidesToScrollTab, $slidesToShowMob, $slidesToScrollMob) {
    if ($element && $element.not('.slick-initialized')) {
        $element.slick({
            dots: $dots,
            arrows: $arrows,
            infinite: $infinite,
            autoplay: $autoplay,
            speed: $speed,
            slidesToShow: $slidesToShow,
            slidesToScroll: $slidesToScroll,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: $slidesToShowTab,
                        slidesToScroll: $slidesToScrollTab,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: $slidesToShowMob,
                        slidesToScroll: $slidesToScrollMob,
                    },
                }
            ],
        });
        $element.closest('.slider-container').find('.shimmer-cards').fadeOut(200).css('min-height', 'auto');
    }
}

// initSlickSlider($element, $dots, $arrows, $infinite, $autoplay, $speed, $slidesToShow, $slidesToScroll)

initSlickSlider($('.slick-slider-tile-1'),true, true, true, true, 500, 1, 1, 1, 1, 1, 1);
initSlickSlider($('.slick-slider-tile-2'),true, true, true, true, 500, 2, 1, 3, 1, 2, 1);
initSlickSlider($('.slick-slider-tile-3'),true, true, true, true, 500, 3, 1, 3, 1, 2, 1);
initSlickSlider($('.slick-slider-tile-4'),true, true, true, true, 500, 4, 1, 3, 1, 2, 1);
initSlickSlider($('.slick-slider-tile-5'),false, true, false, false, 500, 4, 1, 1, 1, 1, 1);
initSlickSlider($('.slick-slider-tile-6'),true, true, true, true, 500, 6, 1, 3, 1, 2, 1);
initSlickSlider($('.js-recentPdpBlock'), false, true, false, false, 500, 4, 1, 3, 1, 1, 1);

document.addEventListener('initialize-hover', function(){
    initSlickSlider($('.recommendation-carousel'), false, true, false, false, 500, 4, 1, 2, 1, 1, 1);
});

// Carousel for color swatches in PLP tiles
// if ($('#product-grid').length) {
//     $('.product-form-swatch__variants').each(function() {
//         if ($(this).children('.product-form__swatch').length > 5 && !$(this).hasClass('slick-initialized')) {
//             $(this).slick({
//             infinite: false,
//             slidesToShow: 6,
//             slidesToScroll: 1,
//             arrows: true,
//             dots: false,
//             speed: 500,
//             });
//         }
//     });
// }